import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import {Container} from 'react-bootstrap'
import {Form} from 'react-bootstrap'
import {Button} from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import {HorizontalLine} from '../HorizontalLine'
import Modal from 'react-bootstrap/Modal'

export default function EditProfile(props) {
  // eslint-disable-next-line      
  const { register, handleSubmit, errors } = useForm();
  const [showEdit, toggleShowEdit] = useState(true);

  const [validated, setValidated] = useState(false);
  const [name, setName] = useState(props.user.name || '');
  const [bio, setBio] = useState(props.user.bio || '');
  const [imgSrc, setImgSrc] = useState(props.user.img_src || '');

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = (data, event, errors) => {
    const form = event.target;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      // console.log("errors: ");
      // console.log("Data & Errors: ", errors);
    } else {
      event.preventDefault();
      // console.log("Data OK: ", data);
      toggleShowEdit(!showEdit)
      props.submitChanges(data)

        
    }
    
    setValidated(true);
  }

  return (
    <Container className="editProfile">
        <HorizontalLine color="light-grey" />
        <Form onSubmit={handleSubmit(onSubmit)} validated={validated} className="details" noValidate> 
                <h5>Editing Profile</h5> <br></br>
                <Form.Group controlId="formBasicText2"  >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} minLength="3" maxLength="80" name="name" ref={register({required: true, minLength: 3, maxLength: 81})} required/>    
                </Form.Group>
                  <span className="invalid">
                    {errors.name && errors.name.type === "minLength" && "Please make sure name is at least 5 characters."}
                    {errors.name && errors.name.type === "maxLength" && "Please make sure name is no more than 81 characters."}
                    {errors.name && errors.name.type === "required" && "Name is required"} 
                  </span> 
                <Form.Group controlId="formBasicText" >
                    <Form.Label>Profile Pic URL</Form.Label>
                    <Form.Control type="url" value={imgSrc} onChange={e => setImgSrc(e.target.value)}minLength="5" maxLength="500" name="imgSrc" ref={register({required: true, maxLength: 500, pattern: { 
                      value: /^(ftp|http|https):\/\/[^ "]+$/, 
                      message: "Incorrect URL Format" }
                    })} required/>    
                </Form.Group>
                  <span className="invalid">
                    {errors.imgSrc && errors.imgSrc.message}
                  </span> 
                <br></br>
                <Form.Group controlId="formBasicBio" >
                    <Form.Label>Bio</Form.Label>
                    <Form.Control as="textarea" rows="3" value={bio ? bio : ""} onChange={e => setBio(e.target.value)} maxLength="500" name="bio" ref={register({maxLength: 501})} />    
                      <span className="invalid">
                        {errors.bio && "Max 500 Characters Limit Exceeded."} 
                        </span> 
                     <br></br><Button variant="primary" size="md" type="submit">Save</Button>&nbsp;&nbsp;
                    <Button variant="secondary" size="md" href="" onClick={() => props.toggleShowEdit(!props.showEdit)}>Cancel</Button>&nbsp; <br></br><br></br>    
                    
                  <Button variant="secondary" size="sm" onClick={handleShow} style={{border: "none", color: "currentColor", backgroundColor: "transparent"}}>Delete My Profile</Button>
                      <Modal show={show} onHide={handleClose}>
                          <Modal.Header closeButton>
                          <Modal.Title>Confirm Profile Data Deletion</Modal.Title>
                          </Modal.Header>
                              <Modal.Body>ALL YOUR TABLES AND CUPPINGS WILL ALSO BE DELETED. 
                              <br></br> <br></br>You can login back again, however, <b>you will not be able recover any previously created tables and cuppings</b>. <br></br> <br></br> Are you sure? (we'll miss you) </Modal.Body>
                          <Modal.Footer>
                              <Button variant="secondary" onClick={handleClose}>Go Back</Button>
                              <Button variant="danger" onClick={props.handleDelete}>Confirm</Button>
                          </Modal.Footer>
                      </Modal>
                </Form.Group>
            </Form>
    </Container>
  );
}